
/* ==========================================================================
   KINOVA — Bosqich 7: player (tomosha) sahifasi — HAQIQIY video/HLS pleer

   Bosqich 6'da bu FAQAT STATIK PLACEHOLDER edi ("hozircha qo'shimcha
   xatti-harakat shart emas"). Endi to'liq pleer mantig'i:
     - HLS.js LAZY import (faqat native HLS qo'llamagan brauzerlarda —
       Safari o'zi <video src="*.m3u8"> ni to'g'ridan-to'g'ri qo'llaydi)
     - manba fallback (bitta manba xato bersa — navbatdagisiga o'tadi,
       `sources` allaqachon ustuvorlik bo'yicha tartiblangan — PlayerController)
     - sifat almashtirish (settings menyusi — har bir "sifat" alohida
       video_sources qatoriga mos, joriy pozitsiya saqlanadi)
     - subtitr yoqish/o'chirish (<track> — brauzer avtomatik `textTracks`ga
       aylantiradi, bu yerda faqat mode almashtiriladi)
     - "davom ettirish" pozitsiyasi (WatchHistory — PlayerController)
     - pozitsiyani davriy saqlash (~30s, watch-progress endpoint, CSRF
       `window.KINOVA_CSRF_TOKEN` orqali — layouts/app.blade.php'ga qarang)

   `window.Icon` — resources/js/icons.js (app.js zanjiri orqali allaqachon
   yuklangan, entries/player.js'ga qarang) — server (@icon() Blade
   direktivasi) va klient (bu fayl) BIR XIL SVG manbasidan foydalanadi,
   ikkalasi orasida hech qanday dublikat/qiyshiqlik yo'q.
   ========================================================================== */
(function (global) {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function formatTime(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  ready(function () {
    var Icon = global.Icon || {};
    var root = document.getElementById('playerRoot');
    if (!root) return; // bo'sh holat (mehmon / video manba yo'q) — pleer yo'q

    var video = document.getElementById('playerVideo');
    var embedBox = document.getElementById('playerEmbed');
    var overlay = document.getElementById('playerOverlay');
    var bigPlay = document.getElementById('playerBigPlay');
    var controls = document.getElementById('playerControls');
    var playPauseBtn = document.getElementById('playerPlayPause');
    var muteBtn = document.getElementById('playerMute');
    var volumeBar = document.getElementById('playerVolumeBar');
    var volumeFill = document.getElementById('playerVolumeFill');
    var volumeWrap = volumeBar ? volumeBar.parentElement : null;
    var timeLabel = document.getElementById('playerTime');
    var progressEl = document.getElementById('playerProgress');
    var bufferedEl = document.getElementById('playerBuffered');
    var playedEl = document.getElementById('playerPlayed');
    var thumbEl = document.getElementById('playerThumb');
    var subtitleBtn = document.getElementById('playerSubtitleToggle');
    var settingsBtn = document.getElementById('playerSettings');
    var qualityMenu = document.getElementById('playerQualityMenu');
    var qualityList = document.getElementById('playerQualityList');
    var fullscreenBtn = document.getElementById('playerFullscreen');

    var sources = [];
    try { sources = JSON.parse(root.getAttribute('data-sources') || '[]'); } catch (e) { sources = []; }
    if (!sources.length || !video) return;

    /* ⚠️ TUZATISH (14-bosqich): `<video controls>` atributi Blade'da
       ATAYLAB qoldirilgan — JS o'chirilgan/yuklanmagan holatda brauzerning
       o'z boshqaruvi ishlashi uchun (progressiv yaxshilash). JS ishga
       tushgan zahoti uni olib tashlaymiz, aks holda ekranda IKKI XIL
       boshqaruv paneli (brauzerning va KINOVA'ning) ustma-ust chiqib,
       sakrash/ovoz tugmalari bir-birini to'sib qo'yardi — foydalanuvchi
       aynan shu holatni "o'tkazib ko'rish yo'q" deb bildirdi. */
    video.removeAttribute('controls');

    var resumeSeconds = parseInt(root.getAttribute('data-resume'), 10) || 0;
    var progressUrl = root.getAttribute('data-progress-url');
    var contentId = root.getAttribute('data-content-id');
    var episodeId = root.getAttribute('data-episode-id') || '';

    var currentIndex = -1;
    var hlsInstance = null;
    var resumeApplied = false;
    var lastSavedAt = 0;

    // ---- Manba biriktirish (HLS/MP4/embed + fallback) ------------------
    function destroyHls() {
      if (hlsInstance) {
        try { hlsInstance.destroy(); } catch (e) { /* e'tiborsiz */ }
        hlsInstance = null;
      }
    }

    function showVideoMode() {
      video.hidden = false;
      embedBox.hidden = true;
      embedBox.innerHTML = '';
      controls.hidden = false;
    }

    function showEmbedMode(url) {
      destroyHls();
      video.hidden = true;
      video.pause();
      controls.hidden = true;
      overlay.classList.add('is-hidden');
      embedBox.hidden = false;
      embedBox.innerHTML = '';
      var iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'no-referrer');

      /* 17-bosqich — TELEGRAM POST VIDJETI.
         Telegram `<iframe>` ichida VIDEO PLEER emas, POSTNING O'ZI
         ko'rsatiladi (matn + video). Uning balandligi o'zgaruvchan va
         16:9 quticha ichiga sig'masligi mumkin, shuning uchun bunday
         embed uchun quticha aylantiriladigan (scroll) qilinadi va
         `scrolling` yoqiladi. Boshqa provayderlarda (YouTube va h.k.)
         eski xatti-harakat O'ZGARMAYDI. */
      if (/(^|\.)t(elegram)?\.me$/.test((function () {
        try { return new URL(url, location.href).hostname.replace(/^www\./, ''); } catch (e) { return ''; }
      })())) {
        embedBox.classList.add('player-embed--post');
        iframe.setAttribute('scrolling', 'yes');
      } else {
        embedBox.classList.remove('player-embed--post');
      }

      embedBox.appendChild(iframe);
    }

    function attach(index, preserveTime) {
      if (index < 0 || index >= sources.length) return false;
      var src = sources[index];
      var resumeTime = preserveTime && video.currentTime > 1 ? video.currentTime : null;
      currentIndex = index;

      if (src.type === 'embed') {
        showEmbedMode(src.url);
        return true;
      }

      showVideoMode();
      destroyHls();

      if (src.type === 'hls' && !video.canPlayType('application/vnd.apple.mpegurl')) {
        import('hls.js').then(function (mod) {
          var Hls = mod && mod.default ? mod.default : mod;
          if (Hls && Hls.isSupported && Hls.isSupported()) {
            hlsInstance = new Hls();
            hlsInstance.loadSource(src.url);
            hlsInstance.attachMedia(video);
            hlsInstance.on(Hls.Events.MANIFEST_PARSED, function () {
              if (resumeTime) video.currentTime = resumeTime;
            });
            hlsInstance.on(Hls.Events.ERROR, function (event, data) {
              if (data && data.fatal) tryNext();
            });
          } else {
            tryNext();
          }
        }).catch(function () { tryNext(); });
      } else {
        video.src = src.url;
        if (resumeTime) {
          video.addEventListener('loadedmetadata', function onMeta() {
            video.currentTime = resumeTime;
            video.removeEventListener('loadedmetadata', onMeta);
          });
        }
      }

      return true;
    }

    function tryNext() {
      if (currentIndex < sources.length - 1 && attach(currentIndex + 1, true)) {
        video.load();
        video.play().catch(function () {});
      }
      // Aks holda oxirgi manbada qoladi — brauzer o'z xato holatini ko'rsatadi.
    }

    video.addEventListener('error', function () {
      if (currentIndex < sources.length - 1) tryNext();
    });

    /* ══ 17-bosqich — AVTOMATIK SIFAT (internet tezligiga qarab) ══════
       Foydalanuvchi talabi: "sayt o'zi internet tezligiga qarab yoki
       ixtiyoriy sifat tanlash orqali 480p yoki 320p ga kamaytirishi
       kerak — foydalanuvchining o'z ixtiyorida bo'lsin".

       ⚠️ Bu HAQIQIY o'lchovga tayanadi, taxminga emas:
          1) `navigator.connection.downlink` (Mbps) — brauzer bergan
             joriy tezlik (Chrome/Edge/Android). Bo'lmasa — o'tkazib
             yuboriladi, soxta qiymat O'YLAB TOPILMAYDI.
          2) `waiting` hodisasi — video BUFERLANIB to'xtaganda
             brauzerning o'zi chiqaradi. Ketma-ket 2 marta to'xtasa,
             demak joriy sifat og'ir — bir pog'ona pastga tushamiz.
          3) Uzoq vaqt (90 s) to'xtamasdan ketsa — bir pog'ona
             yuqoriga ko'tarilamiz.

       Foydalanuvchi menyudan sifatni QO'LDA tanlasa, avtomatik rejim
       O'CHADI va boshqa aralashmaydi (talabning "o'z ixtiyorida
       bo'lsin" qismi). */
    function heightOf(q) {
      var s = String(q || '').toLowerCase();
      if (s === '4k') return 2160;
      var n = parseInt(s, 10);
      return isNaN(n) ? 0 : n;
    }

    // Faqat o'ynatiladigan (embed bo'lmagan) manbalar, balandligi
    // bo'yicha YUQORIDAN PASTGA.
    var ladder = sources
      .map(function (s, i) { return { index: i, height: heightOf(s.quality), type: s.type }; })
      .filter(function (s) { return s.type !== 'embed' && s.height > 0; })
      .sort(function (a, b) { return b.height - a.height; });

    var autoEnabled = ladder.length > 1;
    var stalls = 0;
    var stallTimer = null;
    var steadyTimer = null;

    function ladderPos(index) {
      for (var i = 0; i < ladder.length; i++) {
        if (ladder[i].index === index) return i;
      }
      return -1;
    }

    /* Brauzer bergan tezlikdan (Mbps) mos balandlikni tanlaydi.
       Chegaralar amaliy: 360p ≈ 0.8 Mbit, 480p ≈ 1.4, 720p ≈ 2.8. */
    function heightForDownlink(mbps) {
      if (mbps < 1.2) return 360;
      if (mbps < 2.5) return 480;
      if (mbps < 5) return 720;
      return 99999;
    }

    function bestIndexFor(maxHeight) {
      for (var i = 0; i < ladder.length; i++) {
        if (ladder[i].height <= maxHeight) return ladder[i].index;
      }
      return ladder.length ? ladder[ladder.length - 1].index : 0;
    }

    function initialIndex() {
      if (!autoEnabled) return 0;

      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!c) return 0; // ma'lumot yo'q — eng yuqori sifatdan boshlaymiz

      if (c.saveData) return bestIndexFor(480); // "trafikni tejash" rejimi

      var mbps = typeof c.downlink === 'number' ? c.downlink : null;
      if (mbps === null) return 0;

      return bestIndexFor(heightForDownlink(mbps));
    }

    function stepQuality(direction) {
      if (!autoEnabled) return;
      var pos = ladderPos(currentIndex);
      if (pos < 0) return;
      var next = pos + (direction < 0 ? 1 : -1); // pastga = ro'yxatda keyingi
      if (next < 0 || next >= ladder.length) return;

      attach(ladder[next].index, true);
      video.load();
      video.play().catch(function () {});
      if (typeof renderQualityList === 'function') renderQualityList();
    }

    video.addEventListener('waiting', function () {
      if (!autoEnabled) return;
      stalls++;
      clearTimeout(stallTimer);
      // 30 soniya ichida ketma-ket to'xtashlar hisoblanadi.
      stallTimer = setTimeout(function () { stalls = 0; }, 30000);

      if (stalls >= 2) {
        stalls = 0;
        stepQuality(-1);
      }
    });

    video.addEventListener('playing', function () {
      if (!autoEnabled) return;
      clearTimeout(steadyTimer);
      // 90 soniya bemalol ketsa — bir pog'ona yuqoriga.
      steadyTimer = setTimeout(function () { stepQuality(1); }, 90000);
    });

    attach(initialIndex()); // `sources` ustuvorlik (is_default/sort_order) bo'yicha tartiblangan.

    // ---- "Davom ettirish" pozitsiyasi ------------------------------------
    if (resumeSeconds > 5) {
      video.addEventListener('loadedmetadata', function onMeta() {
        if (!resumeApplied && video.duration && resumeSeconds < video.duration - 5) {
          video.currentTime = resumeSeconds;
        }
        resumeApplied = true;
        video.removeEventListener('loadedmetadata', onMeta);
      });
    }

    // ---- Play / pauza -----------------------------------------------------
    function syncPlayIcon() {
      var playing = !video.paused && !video.ended;
      if (playPauseBtn && Icon.pause && Icon.play) {
        playPauseBtn.innerHTML = playing ? Icon.pause(18) : Icon.play(18);
      }
      if (overlay) overlay.classList.toggle('is-hidden', playing);

      /* 19-bosqich — BREND EKRANI FAQAT BIR MARTA.
       *
       * Ilgari pauza bosilganda to'liq brend ekrani (logotip, kino nomi,
       * tavsif) QAYTA chiqardi va telefonda pastdagi boshqaruvlar ustiga
       * tushib, hammasi aralashib ketardi.
       *
       * Endi kino bir marta boshlangach `is-started` klassi qo'yiladi —
       * shundan keyin pauzada faqat markazdagi katta tugma ko'rinadi.
       */
      if (overlay && playing) overlay.classList.add('is-started');
    }

    function togglePlay() {
      if (video.paused) video.play().catch(function () {});
      else video.pause();
    }

    if (playPauseBtn) playPauseBtn.addEventListener('click', togglePlay);
    if (bigPlay) bigPlay.addEventListener('click', togglePlay);
    /* ⚠️ TUZATISH (14-bosqich): bu yerda ilgari yana bitta
       `video.addEventListener('click', togglePlay)` bor edi. Ikki marta
       bosib sakrash qo'shilgandan keyin video ustida IKKITA `click`
       tinglovchisi qolgan bo'lardi (bittasi darhol ijro/pauza qiladi,
       ikkinchisi 300 ms kutib yana o'sha ishni qiladi) — natijada bitta
       bosishda video ikki marta almashib, "hech narsa bo'lmagandek"
       ko'rinardi. Endi video ustidagi bosishlarni FAQAT pastdagi
       `wireStageTaps()` boshqaradi. */
    video.addEventListener('play', syncPlayIcon);
    video.addEventListener('pause', syncPlayIcon);
    video.addEventListener('ended', syncPlayIcon);
    syncPlayIcon();

    // ---- Progress / seek ----------------------------------------------
    function updateProgress() {
      if (!video.duration) return;
      var pct = (video.currentTime / video.duration) * 100;
      if (playedEl) playedEl.style.width = pct + '%';
      if (thumbEl) thumbEl.style.left = pct + '%';
      if (timeLabel) timeLabel.textContent = formatTime(video.currentTime) + ' / ' + formatTime(video.duration);

      if (bufferedEl && video.buffered && video.buffered.length) {
        var end = video.buffered.end(video.buffered.length - 1);
        bufferedEl.style.width = Math.min(100, (end / video.duration) * 100) + '%';
      }
    }
    video.addEventListener('timeupdate', updateProgress);
    video.addEventListener('progress', updateProgress);
    video.addEventListener('loadedmetadata', updateProgress);

    function seekFromEvent(e) {
      if (!progressEl || !video.duration) return;
      var rect = progressEl.getBoundingClientRect();
      var touch = e.touches && e.touches.length ? e.touches[0]
        : (e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : null);
      var clientX = touch ? touch.clientX : e.clientX;
      if (clientX == null) return;
      var ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      video.currentTime = ratio * video.duration;
      updateProgress();
    }

    /* ⚠️ TUZATISH (14-bosqich): ilgari sakrash (seek) FAQAT sichqoncha
       bilan ishlardi — telefon/planshetda barmoq bilan progress chizig'ini
       surib bo'lmasdi. Endi `touchstart`/`touchmove` ham qo'shildi.
       `{ passive: false }` + `preventDefault()` — barmoq bilan surganda
       sahifa skroll bo'lib ketmasligi uchun. */
    if (progressEl) {
      var seeking = false;

      /* 14-bosqich ("professional darajada dizayn"): kursor turgan
         joydagi VAQTNI ko'rsatuvchi yorliq. Element shu yerda dinamik
         yaratiladi — Blade shabloniga tegilmaydi (pleer sahifasi HAM
         kino HAM qism uchun bitta shablon, uni o'zgartirmaslik
         xavfsizroq). Telefonda CSS uni yashiradi (barmoq ostida
         qolib ketardi). */
      var tipEl = document.createElement('div');
      tipEl.className = 'player-progress__tip';
      tipEl.setAttribute('aria-hidden', 'true');
      progressEl.appendChild(tipEl);

      function showTip(clientX) {
        if (!video.duration) return;
        var rect = progressEl.getBoundingClientRect();
        if (rect.width < 2) return;
        var ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        tipEl.textContent = formatTime(ratio * video.duration);
        // Yorliq chiziq chetidan chiqib ketmasligi uchun cheklaymiz.
        tipEl.style.left = (ratio * 100) + '%';
        tipEl.classList.add('is-visible');
      }
      function hideTip() { tipEl.classList.remove('is-visible'); }

      progressEl.addEventListener('mousemove', function (e) { showTip(e.clientX); });
      progressEl.addEventListener('mouseleave', hideTip);

      function beginSeek() { seeking = true; progressEl.classList.add('is-seeking'); }
      function endSeek() { seeking = false; progressEl.classList.remove('is-seeking'); }

      progressEl.addEventListener('click', seekFromEvent);
      progressEl.addEventListener('mousedown', function (e) { beginSeek(); seekFromEvent(e); });
      global.addEventListener('mousemove', function (e) { if (seeking) { seekFromEvent(e); showTip(e.clientX); } });
      global.addEventListener('mouseup', function () { if (seeking) { endSeek(); hideTip(); } });

      progressEl.addEventListener('touchstart', function (e) {
        beginSeek();
        seekFromEvent(e);
        e.preventDefault();
      }, { passive: false });
      progressEl.addEventListener('touchmove', function (e) {
        if (!seeking) return;
        seekFromEvent(e);
        e.preventDefault();
      }, { passive: false });
      progressEl.addEventListener('touchend', function () { endSeek(); hideTip(); });
    }

    /* ---- ±15 soniya: ikki marta bosish + klaviatura (14-bosqich) ------
       Foydalanuvchi talabi: "ekranga videoni ong tarafini ikki marta
       bossa 15 sekund oldinga, chap tarafga bosganda 15 sekund qaytarsin".

       Ishlash tartibi:
         - Ekranning O'NG yarmiga ikki marta tez bosish  → +15 s
         - Ekranning CHAP yarmiga ikki marta tez bosish  → −15 s
         - Bir marta bosish  → ijro/pauza (avvalgi xatti-harakat)
       Ikki marta bosishni aniqlash uchun 300 ms oyna ishlatiladi — shu
       sababli bitta bosish 300 ms kechikib bajariladi (aks holda ikki
       marta bosishda video ham to'xtab, ham sakrab ketar edi). */
    var SKIP_SECONDS = 15;
    var lastTapAt = 0;
    var lastTapX = 0;
    var singleTapTimer = null;

    function showSkipHint(forward) {
      var hint = document.getElementById(forward ? 'playerSkipFwd' : 'playerSkipBack');
      if (!hint) return;
      hint.classList.add('is-visible');
      setTimeout(function () { hint.classList.remove('is-visible'); }, 550);
    }

    function skip(seconds) {
      if (!video.duration) return;
      video.currentTime = Math.min(video.duration, Math.max(0, video.currentTime + seconds));
      updateProgress();
      showSkipHint(seconds > 0);
    }

    function isRightHalf(clientX) {
      var rect = video.getBoundingClientRect();

      return (clientX - rect.left) > rect.width / 2;
    }

    /** TELEFON/PLANSHET: ikki marta bosish → ±15 s, bir marta → ijro/pauza. */
    function handleStageTap(clientX) {
      var now = Date.now();

      // Ikki marta bosish (300 ms ichida, taxminan bir joyga).
      if (now - lastTapAt < 300 && Math.abs(clientX - lastTapX) < 80) {
        clearTimeout(singleTapTimer);
        lastTapAt = 0;
        skip(isRightHalf(clientX) ? SKIP_SECONDS : -SKIP_SECONDS);

        return;
      }

      lastTapAt = now;
      lastTapX = clientX;

      // Bitta bosish — ikki marta bosish kutilib, keyin bajariladi.
      clearTimeout(singleTapTimer);
      singleTapTimer = setTimeout(function () { togglePlay(); }, 300);
    }

    /* ⚠️ Sensorli ekran va sichqoncha ATAYLAB ALOHIDA boshqariladi:

         • TELEFON (`touchend`) — `handleStageTap()`: ikki marta bosish
           ±15 s, bir marta bosish 300 ms kechikib ijro/pauza.
           `preventDefault()` brauzer keyin qo'shimcha `click` hodisasini
           yubormasligini kafolatlaydi (aks holda har bir tegish IKKI
           marta hisoblanardi).

         • SICHQONCHA (`click`/`dblclick`) — kechikish YO'Q: bosish darhol
           ijro/pauza qiladi (kompyuterda 300 ms kechikish "pleer sekin"
           degan tuyg'u beradi), ikki marta bosish esa `dblclick` bilan
           ±15 s qiladi. Ikki marta bosishda ijro holati ikki marta
           almashadi, ya'ni oxirida O'ZGARMAYDI — faqat sakrash qoladi.
           `_touched` bayrog'i sensorli ekranda kelgan "soxta" sichqoncha
           hodisalarini (ba'zi brauzerlar `preventDefault`ga qaramay
           yuboradi) chetlab o'tadi. */
    var touchedAt = 0;

    video.addEventListener('touchend', function (e) {
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      touchedAt = Date.now();
      handleStageTap(t.clientX);
      e.preventDefault();
    }, { passive: false });

    video.addEventListener('click', function () {
      if (Date.now() - touchedAt < 700) return; // sensorli ekrandan kelgan takror hodisa
      togglePlay();
    });

    video.addEventListener('dblclick', function (e) {
      if (Date.now() - touchedAt < 700) return;
      skip(isRightHalf(e.clientX) ? SKIP_SECONDS : -SKIP_SECONDS);
    });

    /* Klaviatura: strelkalar ±5 s, Shift+strelka ±15 s, probel — ijro,
       M — ovoz, F — to'liq ekran, ↑/↓ — ovoz balandligi.
       Forma maydonida yozilayotganda ishlamaydi (input/textarea). */
    document.addEventListener('keydown', function (e) {
      var tag = (e.target && e.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable) return;

      switch (e.key) {
        case ' ':
        case 'k':
          togglePlay(); e.preventDefault(); break;
        case 'ArrowRight':
          skip(e.shiftKey ? SKIP_SECONDS : 5); e.preventDefault(); break;
        case 'ArrowLeft':
          skip(e.shiftKey ? -SKIP_SECONDS : -5); e.preventDefault(); break;
        case 'ArrowUp':
          video.muted = false;
          video.volume = Math.min(1, video.volume + 0.1);
          syncVolumeIcon(); e.preventDefault(); break;
        case 'ArrowDown':
          video.volume = Math.max(0, video.volume - 0.1);
          syncVolumeIcon(); e.preventDefault(); break;
        case 'm':
          video.muted = !video.muted; syncVolumeIcon(); break;
        case 'f':
          if (fullscreenBtn) fullscreenBtn.click(); break;
        default: break;
      }
    });

    // ---- Ovoz ------------------------------------------------------------
    function syncVolumeIcon() {
      if (!muteBtn || !Icon.volume || !Icon.volumeMute) return;
      muteBtn.innerHTML = (video.muted || video.volume === 0) ? Icon.volumeMute(18) : Icon.volume(18);
      if (volumeFill) volumeFill.style.width = (video.muted ? 0 : video.volume * 100) + '%';
    }
    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted && video.volume === 0) video.volume = 1;
        syncVolumeIcon();
      });
    }
    /* ⚠️ TUZATISH (14-bosqich): ovoz chizig'i ilgari faqat BITTA bosishga
       javob berardi — surib (drag) sozlash va telefonda barmoq bilan
       boshqarish ishlamasdi. Endi sichqoncha surish va `touch` ham bor. */
    if (volumeBar) {
      var volDragging = false;

      function setVolumeFromEvent(e) {
        var rect = volumeBar.getBoundingClientRect();
        if (rect.width < 2) return; // Yopiq holat (hover'siz) — e'tiborsiz.
        var touch = e.touches && e.touches.length ? e.touches[0]
          : (e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : null);
        var clientX = touch ? touch.clientX : e.clientX;
        if (clientX == null) return;
        var ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        video.volume = ratio;
        video.muted = ratio === 0;
        syncVolumeIcon();
      }

      volumeBar.addEventListener('click', setVolumeFromEvent);
      volumeBar.addEventListener('mousedown', function (e) { volDragging = true; setVolumeFromEvent(e); });
      global.addEventListener('mousemove', function (e) { if (volDragging) setVolumeFromEvent(e); });
      global.addEventListener('mouseup', function () { volDragging = false; });

      volumeBar.addEventListener('touchstart', function (e) {
        volDragging = true; setVolumeFromEvent(e); e.preventDefault();
      }, { passive: false });
      volumeBar.addEventListener('touchmove', function (e) {
        if (volDragging) { setVolumeFromEvent(e); e.preventDefault(); }
      }, { passive: false });
      volumeBar.addEventListener('touchend', function () { volDragging = false; });
    }
    if (volumeWrap) {
      volumeWrap.addEventListener('mouseenter', function () { volumeWrap.classList.add('is-active'); });
      volumeWrap.addEventListener('mouseleave', function () { volumeWrap.classList.remove('is-active'); });
    }
    syncVolumeIcon();

    // ---- Subtitr yoqish/o'chirish -----------------------------------------
    function anyTrackShowing() {
      var tracks = video.textTracks;
      for (var i = 0; i < (tracks ? tracks.length : 0); i++) {
        if (tracks[i].mode === 'showing') return true;
      }
      return false;
    }
    if (subtitleBtn) {
      subtitleBtn.addEventListener('click', function () {
        var tracks = video.textTracks;
        if (!tracks || !tracks.length) return;
        var anyShowing = anyTrackShowing();
        for (var j = 0; j < tracks.length; j++) {
          tracks[j].mode = anyShowing ? 'hidden' : (j === 0 ? 'showing' : 'hidden');
        }
        subtitleBtn.classList.toggle('is-active', !anyShowing);
      });
      // Boshlang'ich holat: `<track default>` (is_default subtitr) brauzer
      // tomonidan avtomatik "showing" qilingan bo'lishi mumkin — tugma shu
      // holatni aks ettirishi kerak (Blade `default` atributi — pages/player.blade.php).
      video.addEventListener('loadedmetadata', function syncSubtitleBtn() {
        subtitleBtn.classList.toggle('is-active', anyTrackShowing());
        video.removeEventListener('loadedmetadata', syncSubtitleBtn);
      });
    }

    // ---- Sifat (settings) menyusi -------------------------------------
    function closeQualityMenu() { if (qualityMenu) qualityMenu.hidden = true; }

    if (settingsBtn && qualityMenu && qualityList && sources.length >= 1) {
      /* 17-bosqich — "Avto" endi HAQIQIY rejim (avval u shunchaki
         birinchi manbaga qaytaruvchi yorliq edi). Tanlangan sifat
         yonida belgi turadi, "Avto"da esa hozir qaysi sifat
         ishlayotgani qavs ichida ko'rsatiladi. */
      var options = [{ label: 'Avto', index: -1 }].concat(sources.map(function (s, i) {
        return { label: s.qualityBadge + ' (' + s.quality + ')', index: i };
      }));

      function renderQualityList() {
        if (!qualityList) return;
        qualityList.innerHTML = '';
        options.forEach(function (opt) {
          var isAuto = opt.index === -1;
          var active = isAuto ? autoEnabled : (! autoEnabled && opt.index === currentIndex);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'player-menu__item' + (active ? ' is-active' : '');
          var label = opt.label;

          if (isAuto && sources[currentIndex]) {
            label += ' · ' + sources[currentIndex].quality;
          }

          var checkSvg = active && Icon.check ? Icon.check(14) : '';
          btn.innerHTML = '<span>' + label + '</span>' + checkSvg;
          btn.addEventListener('click', function () {
            if (isAuto) {
              // Avtomatik rejimni qayta yoqamiz va tezlikka mos
              // sifatga o'tamiz.
              autoEnabled = ladder.length > 1;
              stalls = 0;
              var want = initialIndex();
              if (want !== currentIndex) {
                attach(want, true);
                video.load();
                video.play().catch(function () {});
              }
              renderQualityList();
              closeQualityMenu();

              return;
            }

            // Qo'lda tanlov — avtomatik aralashuv TO'XTAYDI.
            autoEnabled = false;
            clearTimeout(steadyTimer);

            if (opt.index !== currentIndex) {
              attach(opt.index, true);
              video.load();
              video.play().catch(function () {});
            }
            renderQualityList();
            closeQualityMenu();
          });
          qualityList.appendChild(btn);
        });
      }

      settingsBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (qualityMenu.hidden) {
          renderQualityList();
          qualityMenu.hidden = false;
        } else {
          closeQualityMenu();
        }
      });
      document.addEventListener('click', function (e) {
        if (!qualityMenu.hidden && !qualityMenu.contains(e.target) && e.target !== settingsBtn) {
          closeQualityMenu();
        }
      });
    } else if (settingsBtn) {
      settingsBtn.hidden = true;
    }

    /* ---- Ijro tezligi (Bosqich 13 — audit topilmasi #26) -------------
       Ilgari pleerda tezlikni o'zgartirish imkoniyati YO'Q edi.
       Tanlangan tezlik `localStorage`da saqlanadi — foydalanuvchi har
       safar qaytadan tanlashi shart emas (saqlash ishlamasa ham pleer
       normal ishlaydi, shuning uchun try/catch ichida). */
    var speedBtn = document.getElementById('playerSpeed');
    var speedMenu = document.getElementById('playerSpeedMenu');
    var speedList = document.getElementById('playerSpeedList');
    var speedLabel = document.getElementById('playerSpeedLabel');
    var SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 2];
    var STORE_KEY = 'kinova.playbackRate';

    function readStoredRate() {
      try {
        var v = parseFloat(global.localStorage.getItem(STORE_KEY));
        return SPEEDS.indexOf(v) !== -1 ? v : 1;
      } catch (e) { return 1; }
    }

    function applyRate(rate) {
      video.playbackRate = rate;
      if (speedLabel) speedLabel.textContent = (rate === 1 ? '1' : String(rate)) + '×';
      try { global.localStorage.setItem(STORE_KEY, String(rate)); } catch (e) { /* ignore */ }
    }

    function closeSpeedMenu() { if (speedMenu) speedMenu.hidden = true; }

    if (speedBtn && speedMenu && speedList) {
      applyRate(readStoredRate());

      // Manba almashganda (sifat o'zgarganda) tezlik tiklanadi —
      // <video> yangi manbani yuklaganda playbackRate 1 ga qaytadi.
      video.addEventListener('loadedmetadata', function () { applyRate(readStoredRate()); });

      speedBtn.addEventListener('click', function (e) {
        e.stopPropagation();

        if (!speedMenu.hidden) { closeSpeedMenu(); return; }

        closeQualityMenu();
        speedList.innerHTML = '';

        SPEEDS.forEach(function (rate) {
          var btn = document.createElement('button');
          btn.type = 'button';
          var active = Math.abs(video.playbackRate - rate) < 0.01;
          btn.className = 'player-menu__item' + (active ? ' is-active' : '');
          var checkSvg = active && Icon.check ? Icon.check(14) : '';
          btn.innerHTML = '<span>' + (rate === 1 ? 'Oddiy (1×)' : rate + '×') + '</span>' + checkSvg;
          btn.addEventListener('click', function () {
            applyRate(rate);
            closeSpeedMenu();
          });
          speedList.appendChild(btn);
        });

        speedMenu.hidden = false;
      });

      document.addEventListener('click', function (e) {
        if (!speedMenu.hidden && !speedMenu.contains(e.target) && !speedBtn.contains(e.target)) {
          closeSpeedMenu();
        }
      });
    }

    /* ---- Video tugagach (Bosqich 13 — audit topilmasi #27) ------------
       Ilgari video tugaganda hech narsa ko'rsatilmasdi. Endi "Keyingi
       qism" / "Qaytadan ko'rish" ekrani chiqadi. */
    var endedEl = document.getElementById('playerEnded');
    var replayBtn = document.getElementById('playerReplay');

    if (endedEl) {
      video.addEventListener('ended', function () { endedEl.hidden = false; });
      video.addEventListener('play', function () { endedEl.hidden = true; });

      if (replayBtn) {
        replayBtn.addEventListener('click', function () {
          endedEl.hidden = true;
          video.currentTime = 0;
          video.play().catch(function () {});
        });
      }
    }

    // ---- To'liq ekran ---------------------------------------------------
    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', function () {
        var stage = root;
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (stage.requestFullscreen) {
          stage.requestFullscreen();
        }
      });
    }

    // ---- Boshqaruv panelini bo'sh turganda yashirish ----------------------
    var hideTimer = null;
    function scheduleHide() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        if (!video.paused) controls.classList.add('is-hidden');
      }, 3000);
    }
    root.addEventListener('mousemove', function () {
      controls.classList.remove('is-hidden');
      scheduleHide();
    });
    root.addEventListener('mouseleave', function () {
      if (!video.paused) controls.classList.add('is-hidden');
    });

    // ---- "Davom ettirish" pozitsiyasini saqlash (Talab #8, ~30s) --------
    function saveProgress(useBeacon) {
      if (!progressUrl || !global.KINOVA_CSRF_TOKEN || !video.duration) return;
      var payload = {
        content_id: contentId,
        episode_id: episodeId || null,
        position_seconds: Math.floor(video.currentTime),
        duration_seconds: Math.floor(video.duration),
      };

      if (useBeacon && navigator.sendBeacon) {
        var blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        navigator.sendBeacon(progressUrl + '?_token=' + encodeURIComponent(global.KINOVA_CSRF_TOKEN), blob);
        return;
      }

      fetch(progressUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': global.KINOVA_CSRF_TOKEN,
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () { /* jim tarzda o'tkazib yuboriladi — keyingi urinish yetadi */ });
    }

    setInterval(function () {
      if (video.paused || !video.duration) return;
      var now = Date.now();
      if (now - lastSavedAt >= 30000) {
        lastSavedAt = now;
        saveProgress(false);
      }
    }, 5000);

    global.addEventListener('pagehide', function () { saveProgress(true); });
  });
})(window);
